import React from 'react';

export class BlogFilter extends React.Component {
	render() {
		const id = this.props.id ?? this.props.name;

		return (
			<li className="form-check">
				<input
					checked={this.props.selected}
					className="form-check-input"
					disabled={this.props.disabled}
					id={id}
					name={this.props.name}
					onChange={this.props.onChange}
					type="checkbox"
				/>
				<label className="ml-2" htmlFor={id}>
					{this.props.label}
				</label>
			</li>
		);
	}
}

export default BlogFilter;
